@if (config) {
  <div
    class="progress-bar"
    [ngStyle]="{ '--progress-bar-height': config.height }"
    [ngClass]="{ '--success': isComplete }"
  >
    @for (segmentConfig of config.segmentDefinitions; track segmentConfig) {
      @if (segmentConfig.value != 0) {
        <div
          class="progress-bar__indicator-container"
          [ngStyle]="{
            '--progress-bar-value': segmentConfig.value,
            '--progress-bar-indicator-color':
              'var(--md-sys-color-' + segmentConfig.colorType + ')',
            '--progress-bar-indicator-hover-color':
              'var(--md-sys-color-on-' +
              segmentConfig.colorType +
              '-container)',
            '--progress-bar-overlay-indicator-color':
              'var(--md-ref-palette-' + segmentConfig.colorType + '80)',
            '--progress-bar-overlay-indicator-hover-color':
              'var(--md-ref-palette-' + segmentConfig.colorType + '90)',
          }"
        >
          <div class="progress-bar__indicator"></div>
        </div>
      }
    }
  </div>
}
